

























import { Component, Vue } from 'vue-property-decorator';
import Socket from '@/api/websocket/socket';
import LogService from '@/api/broadcast/LogService';
import ScreenShot from '@/shared/function/ScreenShot';
import localstorage from '@/store/localstorage';
import AeroguestSupportComponent from '@/components/support/AeroguestSupportComponent.vue';

@Component({
  components: {
    AeroguestSupportComponent
  }
})
export default class PoliciesContainer extends Vue {
  public selected = '';
  private returnPath = '/';
  public showAeroguestSupport = false;
  public isScreenshotLoading: any = true;
  private userIdentifier: any;
  public msgfromaeroguestsupport: any = '';
  public imageScreenshot: any = '';
  public notification = false;

  private async created () {
    this.userIdentifier = localstorage.GetIdentifier();
    this.returnPath = `/${this.userIdentifier.Identifier}/${this.userIdentifier.Token}`;
    Socket.$on('message', this.msgHandler);
    Socket.$on('error', this.msgHandlerError);
  }

  private async beforeDestroy () {
    Socket.$off('message', this.msgHandler);
  }

  public async goBack () {
    if (this.selected === 'termsandconditionsonly') {
      this.$router.go(-1);
    } else {
      this.$router.push(this.returnPath);
    }
  }

  public select (selected: string) {
    this.selected = selected;
    if (selected === 'termsandconditionsonly') {
      selected = 'termsandconditions';
    }

    const path = '/policies/' + selected;
    if (this.$route.path !== path) {
      this.$router.push({ name: selected });
    }
  }

  public async openAeroguestSupport () {
    try {
      this.showAeroguestSupport = true;
      this.isScreenshotLoading = await ScreenShot.openAeroguestSupport('Policies', this.userIdentifier.Identifier, this.userIdentifier.Token);
    } catch (error) {
      LogService.LogInformation(`Web Check In - User pressed on aeroguest-support-button in PoliciesContainer.vue, error: ${error}`, { }, `${this.userIdentifier.Identifier}:${this.userIdentifier.Token}`);
    }
  }

  public closeAeroguestSupport () {
    this.showAeroguestSupport = false;
  }

  private msgHandlerError (error: any) {
    LogService.LogInformation(`Socket Failed in PoliciesContainer.vue, Error: ${error}`, {}, `${this.userIdentifier.Identifier}:${this.userIdentifier.Token}`);
  }

  private msgHandler (msg: any) {
    this.notification = true;
    this.msgfromaeroguestsupport = msg;
  }
}
